import { Vue } from 'vue-property-decorator'
import { ServiceRequestRepository } from './ServiceRequestEconomyUnitRepository'
import ServiceRequestModel from '../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceRequestEconomyUnitController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestEconomyUnitController', new ServiceRequestEconomyUnitController())
  }

  async loadDatatable () {
    return await ServiceRequestRepository.loadDatatable()
  }

  async loadDatatableModel (params) {
    return await ServiceRequestRepository.loadDatatableModel(params)
  }

  async loadForm () {
    return await ServiceRequestRepository.loadForm()
  }

  async loadFormAlterar (params) {
    return await ServiceRequestRepository.loadFormAlterar(params)
  }

  async createUnitCategory (params) {
    return await ServiceRequestRepository.createUnitCategory(params)
  }

  async deleteCategory (id) {
    await ServiceRequestRepository.deleteCategory(id)
  }
}
